<template>
  <div>
    <multiselect
          v-if="locationOptions.length > 1"
          track-by="id"
          label="name"
          :multiple="false"
          :show-labels="false"
          :allow-empty="false"
          :searchable="true"
          :options="locationOptions"
          :value="locationOptions.find(loc => (activeLocation && loc.id === activeLocation.id)) || locationOptions[0]"
          title="Select Location to Configure"
          placeholder="Select Location or Company"
          @select="changeLocation">
      <template slot="option" slot-scope="props">
        <i class="mr-1 fad fa-circle" :class="[msOptionClass(props.option)]"/>
        {{ props.option.name }}
      </template>
    </multiselect>

    <input class="form-control" v-else readonly
          :value="(locationOptions.length && locationOptions[0].name) || 'No locations found'"/>
  </div>
</template>

<script>
import locationService from '@/locations/locations-service'
import exceptionMixin from '@/common/mixins/exception-mixin'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import { mapState } from 'vuex'

export default {
  name: 'tenant-selector',
  mixins: [exceptionMixin, userInfoMixin],
  data () {
    return {
      tenants: [],
      groups: []
    }
  },
  mounted () { this.loadTenants() },
  computed: {
    ...mapState('login', ['activeLocation']),
    locationOptions () {
      const ret = []
      ret.push({ name: this.loggedInUser.userCompanyName + ' (company)', id: 0 })
      this.groups.forEach(group => {
        ret.push(group)
        ret.push(...this.tenants.filter(tenant => tenant.groupId === group.id))
      })
      ret.push(...this.tenants.filter(tenant => !tenant.groupId))
        
      return ret
    },
    msOptionClass () {
      return (option) => {
        return option.id === 0
          ? 'company-mode-fg'
          : option.type === 'GROUP'
            ? 'group-mode-fg ml-3'
            : 'location-mode-fg' + (option.groupId ? ' ml-6' : ' ml-3')
      }
    }
  },
  methods: {
    changeLocation (location) {
      if (!location) { return }
      const locationId = location.id === 0 ? null : location.id
      const query = { locationId }
      this.$router.push({
        name: 'changeLocation',
        query: query
      }).catch(() => {})
    },
    loadTenants () {
      return locationService.getAllTenants(this.userCompanyId)
        .then(allTenants => {
          const allowedTenants = allTenants.filter(tenant => this.accessibleTenants.map(t => t.id).includes(tenant.id))
          allowedTenants.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
          this.tenants = allowedTenants.filter(t => t.type === 'LOCATION')
          this.groups = allowedTenants.filter(t => t.type === 'GROUP')
        })
        .catch(error => {
          this.handleError(error, 'Unable to retrieve locations')
        })
    }
  }
}
</script>

<style scoped>
/* another level of margin-left for location indentation */
.ml-6 { margin-left: 2rem; }
</style>
